import { FunctionComponent } from 'react';

interface CheckboxRadioInputProps {
  type: string;
  name: string;
  index?: number;
  question?: React.ReactNode;
  onClick?: React.MouseEventHandler<HTMLInputElement>;
  defaultChecked?: boolean;
}

export const CheckboxRadioInput: FunctionComponent<CheckboxRadioInputProps> = ({
  type,
  name,
  index,
  question,
  onClick,
  defaultChecked
}) => {
  const inputId = `${name}-${index}`;

  return (
    <div className="checkboxRadio">
      <input
        id={inputId}
        name={name}
        onClick={onClick}
        type={type}
        defaultChecked={defaultChecked}
      />
      <label htmlFor={inputId}>{question}</label>
    </div>
  );
};
